module.exports = __webpack_public_path__ + "img/img8.d9fea53a.svg";